import { PosScanResultDto } from './pos-scan-result.dto';
import { SurfboardCreatePaymentLinkDto } from '../payment-surfboard';

export class PosScanDto {
  id?: number;
  scanId: string;
  merchantId: number;
  isScrollNeeded: boolean;
  paymentLinkData?: SurfboardCreatePaymentLinkDto;
  scanResult?: PosScanResultDto;
  createdDate: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
}